// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"667":"c680edac","884":"c680edac"}[chunkId] + ".chunk.css";
};